<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pFrontFlap"></a><a id="pEndpapers"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a>
<div class="copyright">
<p class="left ">First Mariner Books edition 2013</p>
<p class="left "><a id="px0"></a>Copyright © 2012 by Wael Ghonim</p>
<p class="left ">All rights reserved</p>
<p class="left spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="left spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="left spaceabove1"><em>The Library of Congress has cataloged the print edition as follows:</em></p>
<p class="left ">Ghonim, Wael, date.<br/>
Revolution 2.0: the power of the people is greater than the people in power : a memoir / Wael Ghonim.<br/>
p. cm.<br/>
Includes index.</p>
<p class="left "><span class="smallcaps">ISBN</span> 978-0-547-77398-8</p>
<p class="left "><span class="smallcaps">ISBN</span> 978-0-547-86709-0</p>
<p class="left ">1. Ghonim, Wael, date. 2. Political activists—Egypt. 3. Internet—Political aspects—Egypt. 4. Egypt—History—1981–</p>
<p class="left ">I. Title. II. Title: Memoir and call to action.</p>
<p class="left "><span class="smallcaps">DT</span>107.828.<span class="smallcaps">G</span>445<span class="smallcaps">A</span>3 2012<br/>
962.05'5092—dc23<br/>
[B]  2011042557</p>
<div class="timebreak "> </div>
<p class="left ">Cover design by Brian Moore</p>
<p class="left ">Cover photograph © Khalil Hamra / AP</p>
<p class="left ">Author portrait by Sam Christmas</p>
<p class="left ">Frontispiece photograph © Khaled Desouki / Getty Images</p>
<p class="left spaceabove1">e<span class="smallcaps">ISBN</span> 978-0-547-77404-6<br/>
v5.0621</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?62f56a15